import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'
import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [lang, set_lang] = useState('pt');
    const { pathname } = useLocation()

    const get_info = async () => {

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (Array.isArray(res.data)) {
                    setData(res.data)
                }
            })
            .catch(() => 404)
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(() => {
                            get_info()
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const format_date = (dateStr) => {
        if (!dateStr) return '—';
        const clean = dateStr.split('Z')[0];
        const [datePart, timePart] = clean.split('T');
        if (!timePart) return datePart;
        return `${datePart} (${timePart.substring(0, 5)})`;
    };

    const columns = [
        {
            id: 'cliente',
            name: language[lang].cliente,
            selector: 'info.contacts.cliente.name',
            width: '30% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}>
                    {row.info?.contacts?.cliente?.name || '—'}
                </Link>
            ),
        },
        {
            id: 'obra',
            name: language[lang].field_obra,
            selector: 'info.obra',
            width: '18% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}>
                    {row.info?.obra || '—'}
                </Link>
            ),
        },
        {
            id: 'createdBy',
            name: language[lang].createdBy,
            selector: 'info.responsable.create.name',
            width: '15% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
            cell: (row) => (
                <span>{row.info?.responsable?.create?.name || '—'}</span>
            ),
        },
        {
            id: 'data_admissao',
            name: language[lang].data_admissao,
            width: '12% !important',
            minWidth: '140px !important',
            sortable: true,
            center: true,
            cell: (row) => (
                <span style={{ fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums' }}>
                    {format_date(row.info?.data_admissao)}
                </span>
            ),
        },
        {
            id: 'tabela_pintura',
            name: language[lang].tabela_pintura_title ?? 'Esquema de Tratamento',
            width: '12% !important',
            minWidth: '120px !important',
            sortable: false,
            center: true,
            cell: (row) => (
                <span>
                    {Array.isArray(row.info?.tabela_pintura) ? row.info.tabela_pintura.length : 0} {language[lang].rows ?? 'linhas'}
                </span>
            ),
        },
        {
            id: 'btn',
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '10px !important',
            cell: row =>
                <span>
                    {permissions.current?.edit &&
                        <Link className="button button-update p-0 ps-2"
                            to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }}>
                            <i className="bi bi-pencil"></i>
                        </Link>
                    }
                    {permissions.current?.remove &&
                        <button onClick={() => apagar(row.id)} className="button btn-delete">
                            <i className="bi bi-trash"></i>
                        </button>
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header mb-8">
                                        <div className="d-flex align-items-center justify-content-end">
                                            {permissions.current !== null && (permissions.current.create) && (
                                                <Link
                                                    className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                    to={{ pathname: endpoints.regist }}
                                                    style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                                >
                                                    <span>{language[lang].add_new}</span>
                                                </Link>
                                            )}
                                        </div>
                                    </div>

                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                defaultSortAsc={true}
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                customStyles={{
                                                    rows: { style: { cursor: 'pointer', minHeight: '24px' } },
                                                    headCells: { style: { padding: '2px', fontSize: '12px' } },
                                                    cells: { style: { padding: '2px', fontSize: '12px' } },
                                                }}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}